'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _environment = require('../lib/environment');

var _environment2 = _interopRequireDefault(_environment);

var _environments = require('../config/environments');

var environmentType = _interopRequireWildcard(_environments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @since 2017-06-20 11:15:12
 * @author enzo
 */
var PRODUCT_NAME = 'varyag';
var LOG_COLOR = 'background:#3366CC;color:#fff';

/* eslint-disable */
var sendJSError = function sendJSError(name) {
    return function (_ref) {
        var msg = _ref.msg,
            _ref$level = _ref.level,
            level = _ref$level === undefined ? 'error' : _ref$level,
            tags = _ref.tags,
            _ref$category = _ref.category,
            category = _ref$category === undefined ? 'jsError' : _ref$category;

        window.Owl && window.Owl.addError({ name: name, msg: msg }, { level: level, category: category, tags: tags });
        return true;
    };
};

var logger = function logger() {
    var componentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PRODUCT_NAME;

    return {
        info: function info() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (_environment2.default !== 'production') {
                var _console;

                (_console = console).info.apply(_console, ['%c ' + componentName + ':', LOG_COLOR].concat(args));
            }
        },

        error: function error() {
            var _error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (_environment2.default !== 'production') {
                console.error('%c ' + componentName + ':', LOG_COLOR, _error);
            } else if (_error instanceof Error) {
                var jsOptions = (0, _extends3.default)({
                    msg: _error.message,
                    tags: {
                        errorStack: _error.stack,
                        errorName: _error.name
                    }
                }, config);
                sendJSError(componentName)(jsOptions);
            } else {
                sendJSError(componentName)((0, _extends3.default)({
                    msg: _error
                }, config));
            }
            return true;
        }
    };
};

var exlog = logger();
logger.info = exlog.info;
logger.error = exlog.error;

exports.default = logger;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/varyag-hoc-component/logger/index.js
// module id = 101
// module chunks = 0